<div class="container">
  <main id="content" class="error-container" role="main">
    <div class="row">
      <div class="col-xl-4 col-md-6 col-10 offset-xl-4 offset-md-3 offset-1">
        <div class="error-container">
          <h1 class="error-code">404</h1>
          <p class="error-info">
            Oops, it seems that this page does not exist.
          </p>
        </div>
      </div>
    </div>
  </main>
</div>
